import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type MarriottRoomBlockBannerQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type MarriottRoomBlockBannerQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    accommodationPlacesV2: Array<{
      __typename?: 'AccommodationPlaceV2';
      id: string;
      name?: string | null;
      customName?: string | null;
      accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock'; bookingUrl: string; cutoffDate: string; status: Types.AccommodationPlaceRoomBlockStatus } | null;
    }>;
  } | null;
};

export const MarriottRoomBlockBannerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MarriottRoomBlockBanner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlacesV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accommodationRoomBlock' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMarriottRoomBlockBannerQuery__
 *
 * To run a query within a React component, call `useMarriottRoomBlockBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarriottRoomBlockBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarriottRoomBlockBannerQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMarriottRoomBlockBannerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MarriottRoomBlockBannerQuery, MarriottRoomBlockBannerQueryVariables>) {
  return ApolloReactHooks.useQuery<MarriottRoomBlockBannerQuery, MarriottRoomBlockBannerQueryVariables>(MarriottRoomBlockBannerDocument, baseOptions);
}
export function useMarriottRoomBlockBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarriottRoomBlockBannerQuery, MarriottRoomBlockBannerQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MarriottRoomBlockBannerQuery, MarriottRoomBlockBannerQueryVariables>(MarriottRoomBlockBannerDocument, baseOptions);
}
export type MarriottRoomBlockBannerQueryHookResult = ReturnType<typeof useMarriottRoomBlockBannerQuery>;
export type MarriottRoomBlockBannerLazyQueryHookResult = ReturnType<typeof useMarriottRoomBlockBannerLazyQuery>;
export type MarriottRoomBlockBannerQueryResult = Apollo.QueryResult<MarriottRoomBlockBannerQuery, MarriottRoomBlockBannerQueryVariables>;
